(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('extraDaysHolidaysRow', ['ItemTableService', 'DayService', 'DayschemeService', 'SharedAgendaService', 'Alert', ExtraDaysHolidaysRowDirectiveFn]);

    function ExtraDaysHolidaysRowDirectiveFn(ItemTableService, DayService, DayschemeService, SharedAgendaService, Alert) {

        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/extradaysholidays-row.template.html'

        };
        return directive;

        function link(scope, element, attrs) {
            // if editing -> this is the original backup
            var original = null;

            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                DayschemeService.deactivate(scope.item.id).then(function (result) {
                    Alert.success(result);
                    ItemTableService.deactivate(scope.item, scope.item.vmIndex);
                });
            };


            // cancel editing -> show original
            scope.cancel = function () {
                if (original === null) {
                    ItemTableService.remove(scope.item.vmIndex);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, scope.item.vmIndex);
                    // remove backup
                    original = null;
                } // else
            };

            // copy day
            scope.copy = function () {
                // show (open modal)
                var modalInstance = DayService.showModal(scope.item.date, true, SharedAgendaService.currentUser().id);

                // get result from modal window (on close)
                modalInstance.result.then(function (result) {
                    App.unblockUI();
                    // put to list
                    ItemTableService.put(result[0]);
                });
            };

            // show day
            scope.edit = function (result) {
                App.unblockUI();
                // remove current one to put new one
                ItemTableService.remove(scope.item.vmIndex);
                ItemTableService.put(result);

                // reorder 
                // Important: here whe use built-it sort-function 
                // not very fast, but inserting is not done very often -> 
                // if slow -> use binary search for inserting in sorted-array
                ItemTableService.sort();
            };

        } // link
    }

})();